import CheckroomIcon from "@mui/icons-material/Checkroom";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaletteIcon from "@mui/icons-material/Palette";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import SecurityIcon from "@mui/icons-material/Security";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import lightDarkFabricsImage from "assets/images/dtf/dtf-bot-light-dark-fabrics.png";
import softProductsImage from "assets/images/dtf/dtf-bot-soft-products.png";

const FEATURES = [
  {
    icon: CheckroomIcon,
    label: "Works on Any Fabric or Color",
  },
  {
    icon: AutoAwesomeIcon,
    label: "Vibrant Colors & Ultra-fine Details",
  },
  {
    icon: LocalLaundryServiceIcon,
    label: "Certified for 100+ Washes",
    // showInfo: true,
  },
  {
    icon: VerifiedUserIcon,
    label: "100% ECO Friendly (Made By Certified Inks)",
  },
  {
    icon: AttachMoneyIcon,
    label: "$0.01 per square inch",
  },
  {
    icon: PaletteIcon,
    label: "Wider color gamut — 9 Colors printers with vibrant colors",
  },
  {
    icon: WorkspacePremiumIcon,
    label: "Less to no grainy prints",
  },
  {
    icon: LocalFireDepartmentIcon,
    label: "Instant hot peel release",
    // videoLinkLabel: "watch video",
  },
  {
    icon: SecurityIcon,
    label: "Consistent on repeat orders",
  },
];

const UPLOAD_TABS = [
  {
    id: "upload",
    label: "Upload",
    icon: CloudUploadOutlinedIcon,
  },
  // {
  //   id: "previous-designs",
  //   label: "Previous Designs",
  //   icon: CollectionsOutlinedIcon,
  // },
  // {
  //   id: "create-with-ai",
  //   label: "Create with AI",
  //   icon: AutoFixHighOutlinedIcon,
  // },
  // {
  //   id: "design-studio",
  //   label: "Design Studio",
  //   icon: BrushOutlinedIcon,
  // },
];

const MAX_UPLOAD_FILES = 20;
const PRICE_PER_SQ_IN = 0.02;
const MIN_DIMENSION = 1;
const MAX_DIMENSION = 22;
const MIN_QUANTITY = 1;
const MIN_ORDER_SUBTOTAL = 100;
const RUSH_SAME_DAY_STORAGE_KEY = "dtfTransfersRushSameDay";

const getRushSameDayFee = (itemsSubtotal, rushSameDay = false) =>
  rushSameDay ? Number((Number(itemsSubtotal || 0) / 2).toFixed(2)) : 0;

const getAmountTowardMinOrder = (itemsSubtotal, rushSameDay = false) =>
  Number(
    (
      Number(itemsSubtotal || 0) + getRushSameDayFee(itemsSubtotal, rushSameDay)
    ).toFixed(2),
  );

const meetsMinOrderSubtotal = (itemsSubtotal, rushSameDay = false) =>
  getAmountTowardMinOrder(itemsSubtotal, rushSameDay) >= MIN_ORDER_SUBTOTAL;

const readRushSameDayPreference = () => {
  try {
    return sessionStorage.getItem(RUSH_SAME_DAY_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

const writeRushSameDayPreference = (rushSameDay) => {
  try {
    sessionStorage.setItem(
      RUSH_SAME_DAY_STORAGE_KEY,
      rushSameDay ? "true" : "false",
    );
  } catch {
    // Ignore storage errors (private mode, etc.)
  }
};

const POPULAR_SIZES = [
  { label: '2" x 2" - Tag Print / Neck Label', width: 2, height: 2 },
  { label: '3" x 3" - Small Tag/Sleeve Icon', width: 3, height: 3 },
  { label: '4" x 2" - Name Label/Small Chest Text', width: 4, height: 2 },
  { label: '4" x 4" - Left-Chest Logo', width: 4, height: 4 },
  { label: '5" x 3" - Small Badge Logo', width: 5, height: 3 },
  { label: '5" x 5" - Small Chest/Youth Print', width: 5, height: 5 },
  { label: '6" x 6" - Std Left-Chest/Youth', width: 6, height: 6 },
  { label: '7" x 7" - Small Front (Adult)', width: 7, height: 7 },
  { label: '8" x 8" - Medium Front Print', width: 8, height: 8 },
  { label: '9" x 9" - Large Chest/Med Front', width: 9, height: 9 },
  { label: '10" x 10" - Standard Adult Front', width: 10, height: 10 },
  { label: '11" x 11" - Adult Full Front', width: 11, height: 11 },
];

const PRODUCT_IMAGES = [
  {
    src: lightDarkFabricsImage,
    alt: "Works on Both Light & Dark Fabrics",
  },
  {
    src: softProductsImage,
    alt: "Perfect for Customizing Soft Products",
  },
];

export {
  FEATURES,
  UPLOAD_TABS,
  MAX_UPLOAD_FILES,
  PRODUCT_IMAGES,
  PRICE_PER_SQ_IN,
  MIN_DIMENSION,
  MAX_DIMENSION,
  MIN_QUANTITY,
  MIN_ORDER_SUBTOTAL,
  getRushSameDayFee,
  getAmountTowardMinOrder,
  meetsMinOrderSubtotal,
  readRushSameDayPreference,
  writeRushSameDayPreference,
  POPULAR_SIZES,
};
